import { TextStructure } from './textstructure'
import { SourceDoc } from './sourcedoc'
import { AnswerWebResult } from './answerwebresult'
import { BidEvalWebResult } from './bidevalwebresult'
import { TAElement } from './taelement'
import { WinThemeEval } from './winthemeeval'

export const questionAnchorId = (sha?: string) => sha ? `pmq-${sha}` : ''

export interface Question {
  // meta
  projectsha: string;
  questionsha: string;
  createdate: string;     // ISO date string
  updateddate: string;    // ISO date string
  state: string;
  orderstring: string;

  replylimit: ReplyLimit;
  locks: QuestionLocks;
  numbering?: string;

  // core content
  question: string;
  structure?: string;
  answerobj?: AnswerWebResult;

  sourcedocs: SourceDoc[];
  bideval?: BidEvalWebResult;

  // optional / less critical
  structuretweaks?: TAElement[];
  answertweaks?: TAElement[];
  winthemeeval?: WinThemeEval;

  // derived property (comes from backend)
  totalwords?: number;

  // static snapshot
  static?: QuestionStatic;
  index?: number;
  nousefulsources: boolean;

  // Client-side dirty flag - flipped to true whenever the question is
  // patched via AppContext.updateQuestion, cleared on save. Drives the
  // gold "Save question" affordance in the BidQuestion toolbar.
  modified?: boolean;


}





interface QuestionStatic {
  question: string;
  state: string;
  structure?: string;

  answer?: string;
  answerstructure?: TextStructure;
  replylimit?: ReplyLimit | null;

  sourcedocs: Record<string, boolean>;
}


export interface QuestionLocks {
  question: boolean;
  answer: boolean;
  structure: boolean;
  sources: boolean;
  scoring: boolean;
}

export interface ReplyLimit {
  charcount: boolean;
  answerlimit: number;
  approx: boolean;
  speciallengthstring: SpecialLength;
}

type SpecialLength = "none" | "yesno" | "infoonly";
